import BaseService from '@root/core/class/BaseService';

class forwardingService extends BaseService {
  public getForwardingList = (
    page: number,
    searchBy?: string,
    search?: string
  ) => {
    return this.get(
      `/forwardings?${searchBy ? `searchBy=${searchBy}&` : 'searchBy=&'}${
        search ? `search=${search}&` : ''
      }page=${page}&limit=10`
    );
  };

  public createForwardingMessage = (data: {
    forwardId: number;
    content: string;
    attachment: string[];
    quotationId?: number;
  }) => {
    return this.post('/forwardings/posts', data);
  };
  public uploadFile = (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('attachments', file);
      console.log('Appending file:', file.name);
    });

    return this.post('/forwardings/upload-file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).catch((error) => {
      if (error.response?.status === 413) {
        alert('용량이 너무 큽니다');
      }
      throw error;
    });
  };

  public getQuotationList = () => {
    return this.get('/quotations');
  };
}

export default new forwardingService('/api/v1/seller', true);
